import { render, staticRenderFns } from "./FoxSpinner.vue?vue&type=template&id=262cec61&"
import script from "./FoxSpinner.vue?vue&type=script&lang=js&"
export * from "./FoxSpinner.vue?vue&type=script&lang=js&"
import style0 from "./FoxSpinner.vue?vue&type=style&index=0&id=262cec61&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports